export enum OpenReplayAssistStartOutcome {
    CONNECTED = 'CONNECTED',
    CONNECTION_FAILED = 'CONNECTION_FAILED',
    WAITING_FOR_TRACKER_START = 'WAITING_FOR_TRACKER_START',
    UNAVAILABLE = 'UNAVAILABLE',
}
